/**
 * 대화 개요가 바뀌면 이미 있는 라이브러리 텍스트 칸만 맞춘다.
 * 문서가 없으면 만들지 않는다. 실패해도 대화 저장은 막지 않는다.
 */
export const syncLibraryTextOutline = ({ conversationId, contentType, outline }) => {
  if (!conversationId || !outline) return Promise.resolve(null);
  if (contentType !== 'ppt' && contentType !== 'worksheet') return Promise.resolve(null);
  return import('../api/galleryApi')
    .then(({ syncMyContentOutline }) => syncMyContentOutline({
      conversation_id: conversationId,
      content_type: contentType,
      outline,
    }))
    .catch(() => null);
};
